import { isDevelopment } from '@/utils/env'

import { API_BE_BASE_URL } from '@/configs/constants'

import { DefaultAppHeaders, isUseInternalEndpointFlag } from './fetcher.helpers'

export async function fetchOnServer<TResponse>(
  url: string,
  additionalHeaders: Record<string, string> = {},
  additionalOptions: Record<string, unknown> = {}
): Promise<TResponse> {
  // Use internal base url if it's server side and not development and the flag is on
  const useInternal = !isDevelopment && isUseInternalEndpointFlag

  const baseUrl = useInternal
    ? process.env.NEXT_PUBLIC_INTERNAL_BASE_URL
    : API_BE_BASE_URL

  try {
    const responseRaw = await fetch(`${baseUrl}${url}`, {
      method: 'GET',
      headers: {
        cache: 'force-cache',
        'X-SSR': '1',
        ...DefaultAppHeaders,
        ...additionalHeaders,
      },
      ...additionalOptions,
    })
    if (responseRaw.ok) {
      const response = await responseRaw.json()
      return response as TResponse
    } else {
      const response = await responseRaw.json()
      const message =
        response?.error?.message || 'Error while fetching data in the server'
      throw new Error(message)
    }
  } catch (e) {
    const message = `Error while fetching: ${baseUrl}${url} in the server, Error: ${e?.message}`
    throw new Error(message)
  }
}
